import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    flex: 1,
    borderRadius: '0!important',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  dataTable: {
    flex: 1,
    borderRadius: '0!important',
    '& .MuiDataGrid-root': {
      border: 'none',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #e0e0e0',
    },
  },
});
